import React from 'react';
import { MapPin, Calendar, Award, Users } from 'lucide-react';
const trustPoints = [{
  icon: Calendar,
  text: 'Founded in 2014'
}, {
  icon: MapPin,
  text: 'Based in Leonardtown, Maryland since 2020'
}, {
  icon: Users,
  text: 'Serving Southern Maryland'
}, {
  icon: Award,
  text: 'Quality craftsmanship and attention to detail'
}];
export function AboutSection() {
  return <section className="py-20 bg-gradient-to-br from-purple-50 to-white" data-id="element-26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="text-center mb-12" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-29">
            A Local Custom Apparel Shop You Can Trust
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-30">
          {/* Trust Points */}
          <div className="space-y-6" data-id="element-31">
            {trustPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-32">
                <div className="flex-shrink-0 h-10 w-10 bg-purple-100 rounded-lg flex items-center justify-center text-purple-600" data-id="element-33">
                  <point.icon className="h-5 w-5" data-id="element-34" />
                </div>
                <p className="text-lg text-gray-700 leading-relaxed pt-1" data-id="element-35">
                  {point.text}
                </p>
              </div>)}
          </div>

          {/* Supporting Content */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100" data-id="element-36">
            <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-37">
              Founded in 2014, Teams 'n Tees provides custom screen printing,
              embroidery, and personalized apparel for schools, businesses,
              families, and community organizations. Based in Leonardtown,
              Maryland since 2020, we proudly serve customers throughout
              Southern Maryland with high-quality craftsmanship and personal
              service.
            </p>

            <div className="bg-gradient-to-r from-purple-50 to-teal-50 rounded-xl p-6 mb-8 border border-purple-100" data-id="element-38">
              <p className="text-center text-lg font-semibold text-gray-900" data-id="element-39">
                "Custom apparel made locally in Leonardtown, Maryland."
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-40">
              <a href="/contact" className="flex-1 inline-flex items-center justify-center px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-full transition-colors shadow-sm hover:shadow-md" data-id="element-41">
                Get a Quote
              </a>
              <a href="/contact" className="flex-1 inline-flex items-center justify-center px-6 py-3 border-2 border-purple-600 text-purple-600 hover:bg-purple-50 font-medium rounded-full transition-colors" data-id="element-42">
                Start Your Custom Order
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}